import * as Dialog from '@radix-ui/react-dialog'
import classNames from 'classnames'
import { type ElementRef, forwardRef } from 'react'
import * as styles from './styles'

export type DescriptionProps = React.ComponentPropsWithoutRef<
  typeof Dialog.Description
>
/**
 * @note Radix UI Dialog requires this to be present. If the modal is relatively simple--like a title and some
 * explanatory text--you can just render this in `<Modal.Body>`. If `<Modal.Body>`’s contents are more complex you may
 * want to wrap this in `<VisuallyHidden asChild>`, making it available to accessibility tooling but not visible to the
 * user.
 */
export const Description = forwardRef<
  ElementRef<typeof Dialog.Title>,
  DescriptionProps
>((props, forwardedRef) => (
  <Dialog.Description
    {...props}
    className={classNames(styles.classes.description, props.className)}
    css={styles.description}
    ref={forwardedRef}
  />
))
Description.displayName = 'Lapidary: Description ← Modal'
